module.exports = fox._r("fonts/infinity-icon-set.ttf", __webpack_public_path__ + "fonts/3vEZGlC.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/infinity-icon-set.ttf
// module id = 965
// module chunks = 4